import { css } from '@emotion/react'

const S = {
  basic: css`
    position: relative;
    width: 55px;
    height: 30px;
    border-radius: var(--Radius-Circle);
    background-color: white;
  `,
  text: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
}

export default S
